import React, { useState } from 'react';
import { ScrollView, View, RefreshControl } from 'react-native';
import { ProgramList } from 'LocalGluons';
import { withStore } from 'Store';
import Theme from 'Theme';
// TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
// eslint-disable-next-line no-unused-vars
import { filterOutAdultItemsByCategories } from 'Utils/parentalControlUtils';

const EPG_FETCH_STATE = {
    LOADING: 0,
    DONE: 1,
    ERROR: 2,
    END_REACHED: 3 // when there are no more items
};
const DEFAULT_LIST_MODE = 'live';

const FIVE_MINUTES = 1000 * 60 * 5;

class TvGuidePreview extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            epgItems: [],
            epgFetchState: EPG_FETCH_STATE.DONE,
            promoItem: null,
            secondaryPromoItems: [],
            refreshing: false
        };
        this.refreshTimeout = null;
        this.mounted = false;
        this.scrollY = props.scrollY;
    }

    componentDidMount() {
        this.mounted = true;
        this.fetchEpgFromOffset();
        const { setChildRefresher } = this.props;
        if (setChildRefresher) {
            setChildRefresher(this.doRefresh);
        }
    }

    // TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
    // eslint-disable-next-line no-unused-vars
    componentDidUpdate(_, prevState) {
        // TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
        // eslint-disable-next-line react/prop-types
        const { updatePromoData, promoItemsLoaded } = this.props;
        const { promoItem, secondaryPromoItems } = this.state;

        if (updatePromoData) {
            if (promoItem && secondaryPromoItems.length > 0) {
                promoItemsLoaded(promoItem, secondaryPromoItems);
            }
        }
    }

    componentWillUnmount() {
        this.mounted = false;
        if (this.refreshTimeout) clearTimeout(this.refreshTimeout);
        this.refreshTimeout = null;
    }

    fetchEpgFromOffset = (force = false) => {
        // TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
        // eslint-disable-next-line react/prop-types
        const { appManager, promoItemsLoaded } = this.props;
        const { epgFetchState } = this.state;
        const { LOADING, DONE, ERROR, END_REACHED } = EPG_FETCH_STATE;

        if (epgFetchState === END_REACHED || epgFetchState === LOADING) return;

        this.setState({ epgFetchState: LOADING });
        appManager.api
            .fetchChannels(
                {
                    list: DEFAULT_LIST_MODE,
                    queryScope: DEFAULT_LIST_MODE
                },
                true,
                false,
                !force
            )
            .then(({ items }) => {
                const nextEpgFetchState = items.length ? DONE : END_REACHED;
                const newItems = [...items];

                const promoItem = newItems[0];
                const secondaryPromoItems = [newItems[1], newItems[2]];
                if (typeof promoItemsLoaded === 'function') {
                    promoItemsLoaded(promoItem, secondaryPromoItems, true);
                }

                this.setState(
                    {
                        epgItems: newItems,
                        epgFetchState: nextEpgFetchState,
                        promoItem,
                        secondaryPromoItems,
                        refreshing: false
                    },
                    () => {
                        const firstTimestamp = Math.min(
                            ...newItems.map((item) => item.data?.end).filter((val) => Boolean(val))
                        );
                        if (this.refreshTimeout) clearTimeout(this.refreshTimeout);
                        const timeToRefresh = Math.min(FIVE_MINUTES, firstTimestamp - Date.now());
                        // negative time to refresh means old data - force reload
                        if (timeToRefresh <= 0) {
                            this.fetchEpgFromOffset(true);
                        } else {
                            this.refreshTimeout = setTimeout(this.reloadItems, timeToRefresh);
                        }
                    }
                );
            })
            .catch((error) => {
                console.log(error);
                if (this.mounted) this.setState({ epgFetchState: ERROR, refreshing: false });
            });
    };

    doRefresh = () => {
        this.reloadItems(true);
    };

    reloadItems = (isRefresh = false) => {
        this.setState(
            {
                refreshing: isRefresh,
                epgFetchState: EPG_FETCH_STATE.DONE,
                promoItem: null,
                secondaryPromoItems: []
            },
            async () => {
                await this.fetchEpgFromOffset();
            }
        );
    };

    render() {
        const {
            // TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
            // eslint-disable-next-line react/prop-types
            children,
            // TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
            // eslint-disable-next-line react/prop-types
            style,
            // TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
            // eslint-disable-next-line react/prop-types
            onSelectChannel,
            // TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
            // eslint-disable-next-line react/prop-types
            onSelectProgram,
            // TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
            // eslint-disable-next-line react/prop-types
            setChildRefresher,
            scrollY,
            setScrollY
        } = this.props;
        const { epgItems, epgFetchState, refreshing } = this.state;
        const isEpgLoading = epgFetchState === EPG_FETCH_STATE.LOADING;

        return (
            <ScrollView
                nestedScrollEnabled={true}
                indicatorStyle="white"
                persistentScrollbar
                contentOffset={{ x: 0, y: this.scrollY }}
                refreshControl={
                    !setChildRefresher ? (
                        <RefreshControl
                            colors={[Theme.primaryActiveColor]}
                            tintColor={Theme.primaryActiveColor}
                            refreshing={refreshing}
                            onRefresh={this.doRefresh}
                        />
                    ) : null
                }
                onScroll={(e) => {
                    const y = e.nativeEvent.contentOffset.y;
                    setScrollY(y);
                }}
                scrollEventThrottle={16}
            >
                <View>
                    {children}
                    <ProgramList
                        style={style}
                        items={epgItems}
                        isLoading={isEpgLoading}
                        onSelectChannel={onSelectChannel}
                        onSelectProgram={onSelectProgram}
                    />
                </View>
            </ScrollView>
        );
    }
}

export default withStore(TvGuidePreview);
